import { HttpWorkerAdapter } from './adapters/httpWorker';
import { DisabledAdapter } from './adapters/disabled';
import type { ResearchStorageAdapter } from './types';

let override: ResearchStorageAdapter | null = null;

export function researchUploadUrl(): string {
  const url = import.meta.env.VITE_RESEARCH_UPLOAD_URL;
  return typeof url === 'string' ? url.trim() : '';
}

export function researchUploadToken(): string {
  const token = import.meta.env.VITE_RESEARCH_UPLOAD_TOKEN;
  return typeof token === 'string' ? token.trim() : '';
}

export function createResearchAdapter(): ResearchStorageAdapter {
  const url = researchUploadUrl();
  if (!url) {
    return new DisabledAdapter();
  }
  return new HttpWorkerAdapter(url, researchUploadToken());
}

export function getResearchAdapter(): ResearchStorageAdapter {
  if (override) {
    return override;
  }
  return createResearchAdapter();
}

export function setResearchAdapterForTests(adapter: ResearchStorageAdapter | null): void {
  override = adapter;
}

export function isResearchUploadEnabled(): boolean {
  return getResearchAdapter().isEnabled();
}
